<!-- [팝업] 관련 질환 항목 추가/수정 -->
<template>
  <b-modal
    v-model="showDeskDiseaseEdit"
    cancel-variant="outline-secondary"
    centered
    ok-title="저장"
    cancel-title="취소"
    size="sm"
    :title="(isNew ? '항목 추가' : '항목 수정')"
    no-close-on-esc
    no-close-on-backdrop
    @ok.prevent="submit()"
    @close.prevent="close()"
    @cancel.prevent="close()"
  >
    <validation-observer ref="formRules">
      <b-row class="mt-1">
        <b-col
          cols="12"
        >
          <b-form-group
            label="항목명"
            label-for="disease"
          >
            <validation-provider
              #default="{ errors }"
              name="항목명"
              rules="required"
            >
              <b-form-input
                id="disease"
                v-model="disease"
                placeholder="항목명을 입력하세요.(최대 20자)"
                maxlength="20"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import axios from '@axios'
import { ref, watch, getCurrentInstance } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import { ValidationProvider, ValidationObserver } from "vee-validate"
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { errorFormatter } from '@core/utils/filter'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },

  props: {
    showDeskDiseaseEdit: {
      type: Boolean,
      required: true,
    },
    isNew: {
      type: Boolean,
      required: true,
    },
    editItem: {
      type: Object,
      required: false,
      default: null,
    },
  },

  setup(props, { emit }) {
    watch(
      () => props.editItem,
      newVal => {
        if (newVal && newVal.disease) disease.value = newVal.disease
      },
    )

    const toast = useToast()
    const instance = getCurrentInstance()
    const refs = instance.proxy.$refs
    const pushToast = (variant, title) => {
      let icon
      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }
      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    const disease = ref("")

    const submit = () => {
      const validPromise = refs.formRules.validate()
      validPromise.then(valid => {
        if (!valid) return

        if (!props.isNew && props.editItem) {
          updateDisease()
        } else {
          saveNewDisease()
        }
      })
    }

    const saveNewDisease = () => {
      axios
        .put("/fa/desk-disease/new", { disease: disease.value })
        .then(() => {
          pushToast('success', '신규 등록 완료')
          emit('close', true)
        })
        .catch(error => {
          pushToast('danger', errorFormatter(error, "질환을 등록하는 과정에서 오류가 발생하였습니다."))
        })
    }

    const updateDisease = () => {
      axios
        .patch(
          `/fa/desk-disease/update/${props.editItem.id}`,
          { disease: disease.value },
        )
        .then(() => {
          pushToast('success', '데이터 변경 완료')
          emit('close', true)
        })
        .catch(error => {
          pushToast('danger', errorFormatter(error, "데이터를 변경하는 과정에서 오류가 발생하였습니다."))
        })
    }

    const clear = () => {
      disease.value = ''
    }

    const close = () => {
      clear()
      emit('close', null)
    }

    return {
      close,
      submit,
      disease,
    }
  },
}
</script>
